//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vue/no-mutating-props, vue/require-default-prop */
import QfMColumnProperties from "./qf-m-column-properties.vue";

const camelize = str => str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
});

export default {
    name: "QfColumnEntry",
    components: { QfMColumnProperties },
    props: {
        value: { type: Object },
        index: { type: Number },
        focus: { type: Boolean }
    },
    data() {
        return {
            autoField: null,
            showModal: false,
            deleteOpen: false,
            localValue: {}
        };
    },
    computed: {
        isOdd() {
            return this.index % 2 === 0;
        }
    },
    mounted() {
        window.setTimeout(() => {
            if (this.focus) {
                const { name } = this.$refs;
                name.focus();
            }
        }, 1);

        this.updateAutoField();
    },
    methods: {
        enterOnName() {
            const { field } = this.$refs;
            field.focus();
        },
        enterOnField() {
            this.$emit("addColumn", this.index);
        },
        onNameChange() {
            const { headerName } = this.value;

            if (this.autoField) {
                this.value.field = camelize(headerName);
            }
        },
        onFieldChange() {
            this.updateAutoField();
        },
        openPropsModal() {
            this.localValue = JSON.parse(JSON.stringify(this.value));
            this.showModal = true;
        },
        onUpdate(config) {
            this.$emit("input", config);
        },
        remove() {
            this.$emit("remove", this.index);
        },
        fieldFocus() {
            this.$emit("focus", this.index);
            this.deleteOpen = false;
        },
        updateAutoField() {
            this.autoField = !this.value.field;
        }
    }
};
